

function Tips(props) {
  return 'Tips'
}
export default Tips;